import http from 'hub-http/clients/apiClient';
import applyDefaults from 'MeetingsBase/http/applyDefaults';
export default {
  post: (url, data) => applyDefaults(http.post, url, data),
  put: (url, data) => applyDefaults(http.put, url, data),
  get: (url, data) => applyDefaults(http.get, url, data),
  delete: (url, data) => applyDefaults(http.delete, url, data)
};